<template>
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
      <ul role="list" class="mx-auto mt-20 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3">
        <li v-for="sponsor in sponsoren" :key="sponsor.name">
          <a :href="sponsor.website" target="_blank">
            <img v-if="sponsor.imageUrl" class="aspect-[3/2] w-6/12 rounded-l object-center m-auto" :src="sponsor.imageUrl" :alt="sponsor.name" />
            <h3 class="mt-6 text-lg font-semibold leading-8 tracking-tight text-gray-900">{{ sponsor.name }}</h3>
          </a>
          <ul role="list" class="mt-6 flex gap-x-6">
          </ul>
        </li>
      </ul>
    </div>
</template>
<script>
export default {
  name: 'GridComponent',
  props: {
    msg: String
  },
  data() {
    return {
      sponsoren: [
        {
          name: 'Spacescooter',
          website: 'https://www.spacewheelz.com/',
          imageUrl: 'https://www.spacewheelz.com/cdn/shop/files/SpaceWheelz_logo_incl_white_subscription_277x277_fba179d9-950d-42b4-9fc6-5d035d423765.png?v=1666251624&width=200'
        },
        {
          name: 'Intens Bloemen',
          website: 'https://intensbloemen.nl/',
          imageUrl: 'https://intensbloemen.nl/wp-content/uploads/2020/03/intens-bloemen.png.png'
        },
        {
          name: 'De Boekelse Verleiding',
          website: 'https://www.boekelseverleiding.nl/',
          imageUrl: 'https://www.boekelseverleiding.nl/static/media/logo.a913480f.png'
        },
        {
          name: '1961 De koffie en thee winkel',
          website: 'https://www.1961.nl/',
          imageUrl: 'https://1961.nl/wp-content/uploads/2024/05/Logo-1961-large.png'
        },
        {
          name: 'Vinexperience.nl',
          website: 'https://vinexperience.nl/',
          imageUrl: 'https://vinexperience.nl/wp-content/uploads/2024/01/logo-v2-removebg.png'
        },
        {
          name: 'De griek Boekel',
          website: 'https://degriek-boekel.nl/',
          imageUrl: 'https://degriek-boekel.nl/wp-content/themes/yootheme/cache/2f/Logo-De-Griek-Boekel-2fb3c290.webp'
        },
        // {
        //   name: 'Bij Mies',
        //   website: 'https://www.bijmies.nl/',
        //   imageUrl: 'https://www.bijmies.nl/wp-content/uploads/2022/02/Bij-Mies_logo.png'
        // },
        // {i
        //   name: 'Bijzonder design store',
        //   website: 'https://www.bijzonderdesignstore.nl/',
        //   imageUrl: 'https://cdn.webshopapp.com/shops/253187/themes/139166/assets/logo.png?20201228123625'
        // },
        // {
        //   name: 'Boekeldruk',
        //   website: 'https://www.boekeldruk.nl/',
        //   imageUrl: 'img/boekeldruk.jpg'
        // },
        {
          name: 'Fietsland',
          website: 'https://www.fietslandboekel.nl/',
          imageUrl: 'https://fietslandboekelnl.cdn.maxicms.nl/templates/layout/logo.png'
        },
        {
          name: 'Infraway',
          website: 'https://infraway.nl/',
          imageUrl: 'img/infraway.png'
        },
        {
          name: 'AHB geluid / dj Sleeve',
          website: 'http://www.dj-sleeve.nl/',
          imageUrl: 'img/djsleeve.jpg'
        },
        {
          name: 'Verstegen reclame & belettering',
          website: 'https://www.mverstegen.nl/',
          imageUrl: 'https://www.mverstegen.nl/main_img/main/VR_01_07.jpg'
        },
        {
          name: 'Algonkin',
          website: 'http://www.algonkin.nl/',
          imageUrl: 'img/algonkin.jpg'
        },
        {
          name: 'Gems and Balance',
          website: 'https://www.gemsandbalance.nl/#ContactRoute',
          imageUrl: 'https://lirp.cdn-website.com/4bcfcefb/dms3rep/multi/opt/gems-balance-logo-41e59a04-f3757c92-163w.png'
        },
        {
          name: 'van Rijbroek',
          website: 'https://www.vanrijbroekmode.nl/',
          imageUrl: 'https://www.vanrijbroekmode.nl/wp-content/uploads/2019/05/Rijbroek_logo.png'
        },
        {
          name: 'Slimpie',
          website: 'https://www.slimpie.com/',
          imageUrl: 'https://www.slimpie.com/build/images/logo-slimpie.0679926c.svg'
        },
        {
          name: 'Farmfrites',
          website: 'https://www.farmfrites.com/nl-nl/',
          imageUrl: 'https://www.farmfrites.com/dist/images/Logo.png'
        },
        // {
        //   name: 'Coop Venhorst',
        //   website: 'https://www.coop.nl/supermarkt/venhorst-kanters/3681?gclid=Cj0KCQjwxYOiBhC9ARIsANiEIfY0Q5HgzVRpVHduJpQv-cl1V0W6qfDyE5DHx_Ua-At7B_Aj9mrghY0aAqNUEALw_wcB&gclsrc=aw.ds',
        //   imageUrl: 'img/coop.png'
        // },
        // {
        //   name: 'Bakker van de Ven',
        //   website: 'https://bakkervandeven.nl/',
        //   imageUrl: 'img/bakkervandeven.jpg'
        // },
        {
          name: 'Mikkis',
          website: 'https://www.mikkis.nl/',
          imageUrl: 'https://primary.jwwb.nl/public/t/l/p/temp-svrjucecuauqghcyuzfg/3j4grh/6d1fa590-dc20-4bab-86a2-a578caa453f9.png'
        },
        // {
        //   name: 'Kristallen & Zo',
        //   website: 'https://kristallenenzo.nl/',
        //   imageUrl: 'https://kristallenenzo.nl/wp-content/uploads/2019/09/KZ-Logo_RGBkopie-3.png'
        // },
        // {
        //   name: 'D\'n Houten Tol',
        //   website: 'https://dnhoutentol.nl/',
        //   imageUrl: 'https://dnhoutentol.nl/wp-content/uploads/2020/03/cropped-Transparant-1-e1585044882240-1.png'
        // },
        {
          name: 'Het Sieraad',
          website: 'https://www.hetsieraadonline.nl/',
          imageUrl: 'https://www.hetsieraadonline.nl/templates/bychanelle-2015-front/images/het-sieraad-webshop.png'
        },
        {
          name: 'Nootkracht',
          website: 'https://www.nootkracht.nl/',
          imageUrl: 'https://primary.jwwb.nl/public/z/e/b/temp-bhpzfmoyoawpoleycumm/qoyqu6/nootkracht_logo_bruincontourovaal-1.webp'
        },
        // {
        //   name: 'Coppens Warenhuis',
        //   website: 'https://www.coppenswarenhuis.nl/',
        //   imageUrl: 'img/coppens.png'
        // },
        {
          name: 'NC Tuinservice',
          website: '',
          imageUrl: 'img/nc_tuinservice.jpg'
        },
        {
          name: 'Peelpop',
          website: 'https://www.peelpop.nl/',
          imageUrl: 'img/peelpop.jpg'
        },
        // {
        //   name: 'Kinderopvang Elsendorp',
        //   website: 'https://www.kinderopvang-elsendorp.nl/',
        //   imageUrl: 'img/kinderopvang_elsendorp.jpg'
        // },
        // {
        //   name: 'Van Geloven',
        //   website: 'https://www.vangeloven.com/',
        //   imageUrl: 'img/vangeloven.svg'
        // },
        {
          name: 'Krullen en Spullen',
          website: 'https://www.krullenenspullen.nl/',
          imageUrl: 'img/krullenenspullen.png'
        },
        // {
        //   name: 'Strik Elektrotechniek',
        //   website: 'https://strik-elektrotechniek.nl/',
        //   imageUrl: 'img/strik_elektrotechniek.png'
        // },
        {
          name: 'Fresh Valley',
          website: 'https://freshvalley.nl/',
          imageUrl: 'https://freshvalley.nl/wp-content/uploads/2023/07/Logo.svg'
        },
        // {
        //   name: 'Haegens kraanverhuur',
        //   website: 'https://haegenskraanverhuur.nl/',
        //   imageUrl: 'img/haegens.png'
        // },
        {
          name: 'Blizz',
          website: 'https://www.blizzboekel.nl/',
          imageUrl: 'img/blizz.jpg'
        },
        {
          name: 'Verhoeven Wheels',
          website: 'https://www.verhoevenwheels.nl/',
          imageUrl: 'data:image/jpeg;base64,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'
        },
        {
          name: 'White Rose Brocante',
          website: 'https://www.whiterosebrocante.nl/',
          imageUrl: 'img/whiterosebrocante.jpg'
        },
        {
          name: 'Salon Leff',
          website: 'http://www.salonleff.nl/',
          imageUrl: 'img/leff.png'
        },
        {
          name: 'Gerry v. Exel Keurslager',
          website: 'https://vanexel.keurslager.nl/',
          imageUrl: 'img/gerryvanexel.svg'
        },
        {
          name: 'van Kaathoven',
          website: 'https://www.vankaathovengroep.nl/',
          imageUrl: 'img/vankaathoven.svg'
        },
        {
          name: 'Arts evenementen',
          website: 'https://www.artsevenementen.nl/',
          imageUrl: 'https://artsevenementen.nl/wp-content/uploads/2024/01/arts-evenementen-logo.png'
        },
        {
          name: 'Electroworld Wim v.d. Broek',
          website: 'https://www.electroworld.nl/',
          imageUrl: 'img/electroworld.svg'
        },
        {
          name: 'Jos Janssen Timmerwerken',
          website: 'https://www.goudengids.nl/nl/bedrijf/Boekel/L120604318/Jos+Janssen+Timmerwerken+%26+Renovatie/',
          imageUrl: null
        },
        // {
        //   name: 'Hema Boekel',
        //   website: 'https://winkels.hema.nl/nl/boekel/hema-boekel',
        //   imageUrl: 'https://dynl.mktgcdn.com/p/OdeVm5o6yvX5MMZOgjq63ZkZ7F2l_61CsSTJLyRWmWw/70x70.png'
        // },
        {
          name: 'Beautysalon All in One',
          website: 'https://beautysalonallinone.nl/',
          imageUrl: 'img/beautysalonallinone.png'
        },
        // {
        //   name: 'Gemakswinkel Ton Kanters',
        //   website: 'https://tonkanters.nl/',
        //   imageUrl: 'img/tonkanters.jpg'
        // },
        {
          name: 'Bakkerij Merks',
          website: 'https://bakkerijmerks.nl/',
          imageUrl: 'https://bakkerijmerks.nl/wp-content/uploads/2018/04/logo.png'
        },
        // {
        //   name: 'Marco van Delst Installatietechniek',
        //   website: 'https://www.vandelst.nl/',
        //   imageUrl: 'https://www.vandelst.nl/wp-content/uploads/2016/03/Logo-van-Delst-Installatietechniek-Boekel.jpg'
        // },
        // {
        //   name: 'De Griek Boekel',
        //   website: 'https://degriek-boekel.nl/',
        //   imageUrl: 'https://degriek-boekel.nl/wp-content/themes/yootheme/cache/0d/Logo-De-Griek-Boekel-0df0cee1.webp'
        // },
        // {
        //   name: 'JP Jansen Groenten en Fruit',
        //   website: 'https://www.facebook.com/p/JP-Jansen-Groente-en-Fruit-100071156394676/',
        //   imageUrl: 'img/jpjansen.jpg'
        // },
        {
          name: 'Regiobank Boekel',
          website: 'https://www.regiobank.nl/uw-adviseur/wolters-advies-in-boekel.html?s_kwcid=AL!6157!3!603413229316!e!!g!!regiobank%20boekel&gclid=CjwKCAjwg-GjBhBnEiwAMUvNW_W1C_58ZnHGYZL0JAl_8sqs4WHTlxv1epo-eYmUuO4gkMrouPTgnhoCFooQAvD_BwE',
          imageUrl: 'img/regiobank.png'
        },
        {
          name: 'Binqer',
          website: 'https://www.binqer.nl/',
          imageUrl: 'https://www.binqer.nl/static/version1718241792/frontend/Binqer/default/nl_NL/images/logo.svg'
        },
        {
          name: 'Smulbox Boekel',
          website: 'https://tonkanters.nl/food-automaten/',
          imageUrl: 'img/smulbox.png'
        },
        {
          name: 'SVH Meubelservice',
          website: 'https://www.svhmeubelservice.nl/',
          imageUrl: 'https://www.svhmeubelservice.nl/wp-content/uploads/2016/02/Logo1-e1456393144133.png'
        }
        // {
        //   name: 'Plus boekel',
        //   website: 'https://www.plus.nl/supermarkten/boekel_plus-boekel_962?gclid=CjwKCAjwg-GjBhBnEiwAMUvNW3zODdOXobXbWExn-aKU9R134rnRMajCGpFJ4C4OfKrSsLW2cadZNhoCvXQQAvD_BwE',
        //   imageUrl: 'img/plus.png'
        // },
        // {
        //   name: 'Medical Event Service',
        //   website: 'https://medicaleventservice.nl/',
        //   imageUrl: 'img/medicaleventservice.png'
        // },
        // {
        //   name: 'D\'n Hijzelaar',
        //   website: 'http://www.denhijzelaar.nl/',
        //   imageUrl: 'img/hijzelaar.jpg'
        // },
        // {
        //   name: 'E&R Service',
        //   website: 'https://www.google.com/search?q=e%26r+service+boekel&rlz=1C1VDKB_nlNL991NL991&oq=E%26R&aqs=chrome.0.69i59j69i57.1710j0j7&sourceid=chrome&ie=UTF-8',
        //   imageUrl: 'img/erservice.png'
        // },
        // {
        //   name: 'Schonenberg',
        //   website: 'https://www.schonenbergplant.nl/',
        //   imageUrl: 'https://www.schonenbergplant.nl/wp-content/themes/schonenberg/assets/img/logo2.svg'
        // },
        // {
        //   name: 'BJC Tools',
        //   website: 'https://bjctools.nl/',
        //   imageUrl: 'img/bjctools.png'
        // },
        ],
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
